module.exports = __webpack_public_path__ + "img/complete.b283a406.svg";